import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogueBase from './DialogueBase';
import Button from '../Button';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: 0,
  },
  section: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  header: {
    padding: 0,
  },
  icon: {
    color: theme.palette.common.tealish,
    marginRight: '1rem',
  },
  button: {
    minWidth: '8rem',
    padding: '1rem',
  },
}));

const TaskComplete = ({open, next, title, message}) => {
  const classes = useStyles();
  return (
    <DialogueBase
      open={open}
      onClose={next}
      title={title}
      aria-labelledby="sign-up-cta"
    >
      <div className={classes.content}>
        <div className={classes.section}>
          <CheckCircleOutlineIcon fontSize="large" className={classes.icon}/>
          <Typography variant="h2" color="primary" className={classes.header}>
            {message}
          </Typography>
        </div>
        <div className={classes.section}>
          <Button
            variant="contained"
            label="OK"
            cssStyle="large"
            pointer="right"
            aria-label="OK"
            onClick={next}
            className={classes.button}
          />
        </div>
      </div>
    </DialogueBase>
  );
};

TaskComplete.propTypes = {
  open: PropTypes.bool.isRequired,
  next: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default TaskComplete;
